import React, { FC, RefObject, useCallback } from 'react';
import { isNumber } from 'lodash';
import { NumberField } from '@cld/number-field';
import { CUSTOM_PRESET_MAX_SIZE } from '../../../../../../constants/general';
import { useOptions } from '../../../../../../selectors';
import { useHandleParamChange } from '../hooks/useHandleParamChange';

export interface SizeInputProps {
  placeholder: string,
  dimension: 'width' | 'height',
  inputRef?: RefObject<HTMLInputElement>,
}

export const SizeInput: FC<SizeInputProps> = ({ placeholder, dimension, inputRef }) => {
  const { customPreset } = useOptions();
  const size = customPreset.params[dimension] ? String(customPreset.params[dimension]) : '';

  const handleParamChange = useHandleParamChange();

  const handleChange = useCallback((newSize: string) => {
    const newSizeInt = parseInt(newSize, 10);
    if (!newSize || (isNumber(newSizeInt) && newSizeInt >= 1 && newSizeInt <= CUSTOM_PRESET_MAX_SIZE)) {
      handleParamChange(dimension, newSizeInt);
    }
  }, [handleParamChange, dimension]);

  return (
    <NumberField
      size="xs"
      placeholder={placeholder}
      value={size}
      min={1}
      max={CUSTOM_PRESET_MAX_SIZE}
      numericDecorator={false}
      onChange={handleChange}
      inputRef={inputRef}
      data-test={`custom-preset-${dimension}-input`}
    />
  );
};
